import YBatchUpload from './src'

YBatchUpload.install = Vue => {
  Vue.component(YBatchUpload.name, YBatchUpload)
}

export default YBatchUpload
